import React, {  useEffect, useRef } from 'react';
import 'animate.css';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import fractional from '../../Assests/images/home_images/what-is-fractional-img.webp'
import AnimatedContent from '../Common/AnimatedContent';
import { LazyLoadImage } from 'react-lazy-load-image-component';


const textVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
  }),
};

const Wfractional = () => {
  const cardRef = useRef(null);
  const boxTeamRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === "#aboutus") {
      boxTeamRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
        }
      },
      { threshold: 0.3 }
    );

    const currentCard = cardRef.current;

    if (currentCard) {
      observer.observe(currentCard);
    }

    return () => {
      if (currentCard) observer.unobserve(currentCard);
    };
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const text = "What is fractional ownership in real estate?";
  const characters = text.split("");

  return (
    <section ref={boxTeamRef} className="section-contact section-box-team style-2 pb-0">
      <div className="tf-container">
        <div className="row d-flex align-items-center flex-column-reverse flex-md-row">
          <div className="col-lg-6">
            <div className="content-inner">
              <div ref={ref} className="heading-section mb-48" loading="lazy" style={{ whiteSpace: "nowrap" }}>
                <h2 className="title text-start balance text-h2">
                  {characters.map((char, i) => (
                    <motion.span
                      key={i}
                      className="inline-block"
                      variants={textVariants}
                      initial="hidden"
                      animate={inView ? "visible" : "hidden"}
                      custom={i}
                    >
                      {char}
                    </motion.span>
                  ))}
                </h2>
               
              </div>
              <div className="content mb-48 animate__fadeInUp animate__animated">
                <AnimatedContent
                  distance={25}
                  direction="vertical"
                  reverse={false}
                  config={{ tension: 80, friction: 20 }}
                  initialOpacity={0.2}
                  animateOpacity
                  scale={1.1}
                  threshold={0.2}
                >
                  <p className="text-1 description-1 mb-16">
                    Fractional ownership in real estate is a shared ownership model where multiple individuals or entities purchase a fraction of a property. This allows investors to collectively own and share the costs, benefits, and usage rights of high-value assets such as farmland, plots, vacation homes, commercial properties, or luxury residences.
                  </p>
                  <h3 className="title text-h4">Own More, Spend Less: Smart Shared Property Ownership.</h3>
                </AnimatedContent>
              </div>
            </div>
          </div>

          <div className="col-lg-6 d-flex align-items-center justify-content-center">
            <div className="image-wrap w-100 h-100">
              <LazyLoadImage className="lazyload w-100 h-100 object-fit-cover" src={fractional} alt="CoOwnSpace Fractional Ownership" />
            </div>
            {/* <div className="wrap-image relative">
              <div
                ref={cardRef}
                className={`image-wrap hover-img-wrap img-1 ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
              >
                <img className="about-img1 lazyload parallax-img" src={secbox} alt="CoOwnSpaceImage 1" />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Wfractional;
